/* global axios */
import ApiClient from '../ApiClient';

// T-248: a linha do Bira na lista de conversas por time. Ele não é um time no banco; esta é uma
// linha calculada com a mesma forma das outras.
class BiraSummaryAPI extends ApiClient {
  constructor() {
    super('fandata/bira_summary', { accountScoped: true });
  }

  get({ since, until } = {}) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new BiraSummaryAPI();
